import React, { useState } from "react";
import Modal from "react-modal";

Modal.setAppElement("#root");

interface ConfirmationModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  onConfirm: ((comment: string) => void) | (() => void);  // Modified type
  title: string;
  message: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  onConfirmAction?: ((comment: string) => void) | (() => void);  // Modified type
  requireComment?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onRequestClose,
  onConfirm,
  title,
  message,
  confirmButtonText = "Confirm",
  cancelButtonText = "Cancel",
  onConfirmAction,
  requireComment = false,
}) => {
  const [comment, setComment] = useState("");

  const handleConfirm = () => {
    if (onConfirmAction) {
      if (requireComment) {
        (onConfirmAction as (comment: string) => void)(comment);
      } else {
        (onConfirmAction as () => void)();
      }
    } else {
      if (requireComment) {
        (onConfirm as (comment: string) => void)(comment);
      } else {
        (onConfirm as () => void)();
      }
    }
    setComment(""); // Réinitialiser le commentaire après la confirmation
  };

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "700px",
      height: requireComment ? "500px" : "300px",
      padding: "20px",
      backgroundColor: "white",
      color: "#36458e",
    },
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose} style={customStyles}>
      <h2>{title}</h2>
      <p style={{ fontSize: "18px", marginBottom: "20px" }}>{message}</p>
      {requireComment && (
        <div style={{ marginBottom: "20px" }}>
          <label htmlFor="comment" style={{ display: "block", marginBottom: "8px" }}>
            Comment :
          </label>
          <textarea
            id="comment"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            style={{
              width: "100%",
              height: "200px",
              padding: "8px",
              marginBottom: "16px",
              borderRadius: "4px",
              border: "1px solid #ccc",
            }}
            placeholder="Please give a detailed explanation of what changes are needed in the KPI questionnaire"
          />
        </div>
      )}
      <div style={{ display: "flex", justifyContent: "center", gap: "20px", marginTop: "20px" }}>
        <button onClick={onRequestClose} className="big-button">
          {cancelButtonText}
        </button>
        <button 
          onClick={handleConfirm} 
          className="big-button"
          disabled={requireComment && !comment.trim()}
        >
          {confirmButtonText}
        </button>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;